import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import OMGApi from '../../../../APIs/OMGApi';
import { NativeUtils } from '../../native/native.utils';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import { Utils } from '../../utils';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { ServiceProduct } from '../../gnwp/service-product';

export class OpenOnlineMessagesPostLoginAction extends PostLoginActionBase {
    private _sessionSimpleStoreService: SessionSimpleStoreService;
    private _utils: Utils;
    private _serviceProduct: ServiceProduct;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.OMGGetWaitingMessages,
            'OpenOnlineMessagesPostLoginAction',
            state,
        );

        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
        this._utils = Container.get(Utils);
        this._serviceProduct = Container.get(ServiceProduct);
    }

    protected override doAction = async (): Promise<boolean> => {
        const data = {
            ProductPackage: this._window.pageContextManager
                .getDeviceData()
                .productPackage.toString(),
        };
        const { response, errorResponse } = await OMGApi.GetWaitingMessages(data);
        if (response?.IsOk && response.MessagesDetails?.length > 0) {
            await NativeUtils.showBottomBar(false);

            this._showOmg(response.MessagesDetails);
        } else {
            if (errorResponse) {
                this._logger.error(`_internalExecute`, errorResponse);
            } else if (!response?.IsOk) {
                this._logger.error(
                    `_internalExecute, error code: ${response?.ErrorCode || '-'}, description: ${
                        response?.ErrorDescription || '-'
                    }`,
                );
            }
            this.completeAction();
        }
        return false;
    };

    private _showOmg = (messageData) => {
        let externalLinkInPopUp = '1';
        if (this._utils.findIfIsNative()) {
            externalLinkInPopUp = '0';
        }

        const specificNavigation = `
        <XML>
            <CallbackDomain>${this._window.location.origin}</CallbackDomain>
            <ResponseFormat>\'JSON\'</ResponseFormat>
            <ExternalLinkInPopUp>${externalLinkInPopUp}</ExternalLinkInPopUp>
            ${encodeURIComponent(messageData)}
        </XML>
        `;

        var showContainerCloseButton = false;

        this._sessionSimpleStoreService.set('isOmgMsg', 'true');
        const subBrandId = this._window.pageContextManager.getBrandData().subBrandId;
        const omgProductPackage = 76;

        this._serviceProduct.openServiceAuthenticated({
            subBrandId,
            productPackageId: omgProductPackage,
            additionalActivationParameters: specificNavigation,
            width: 0,
            height: 0,
            showCloseButton: showContainerCloseButton,
        });
    };
}
